var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-sere-2.162e7c60.png","uri@2x": __webpack_public_path__ + "icon-sere-2.2e09343a.png","uri@3x": __webpack_public_path__ + "icon-sere-2.a53df36a.png",
    width: 20,
    height: 20
});